module.exports = __webpack_public_path__ + "static/media/pt.33f3d5c9.svg";